import { getKeys as s } from "./types3.mjs";
import { getColorModePalette as n } from "./utils8.mjs";
const r = ({
  groupKey: o,
  mode: e,
  variant: c
}) => {
  const t = n({ mode: e, variant: c });
  return s(t[o]).reduce(
    (p, u) => {
      const g = t[o][u].value;
      return p[u] = g, p;
    },
    {}
  );
}, f = (o, e) => ({
  action: r({
    mode: e,
    groupKey: "action",
    variant: o
  }),
  background: r({
    mode: e,
    groupKey: "background",
    variant: o
  }),
  common: r({
    mode: e,
    groupKey: "common",
    variant: o
  }),
  error: r({
    mode: e,
    groupKey: "error",
    variant: o
  }),
  grey: r({
    mode: e,
    groupKey: "grey",
    variant: o
  }),
  info: r({
    mode: e,
    groupKey: "info",
    variant: o
  }),
  other: r({
    mode: e,
    groupKey: "other",
    variant: o
  }),
  primary: r({
    mode: e,
    groupKey: "primary",
    variant: o
  }),
  secondary: r({
    mode: e,
    groupKey: "secondary",
    variant: o
  }),
  success: r({
    mode: e,
    groupKey: "success",
    variant: o
  }),
  text: r({
    mode: e,
    groupKey: "text",
    variant: o
  }),
  warning: r({
    mode: e,
    groupKey: "warning",
    variant: o
  })
});
export {
  f as compilePaletteVariant
};
//# sourceMappingURL=compilePaletteVariant.mjs.map
